define('adminAnaAssayTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('anaassays.details.tabTitle'),
      isDefault: true
    }
  ];
});
